import { Renderer, RendererProps } from 'amis';
import React from 'react';

import { AIPlcCoder } from './components/AIPlcCoder';
import type { PlcLanguageType } from './types';
import './styles/plcCoder.css';

// ============================================
// Props 定义
// ============================================

export interface AIPlcCoderPluginProps extends RendererProps {
  /** 初始代码 */
  readonly initialCode?: string;
  /** 初始语言 */
  readonly initialLanguage?: PlcLanguageType;
  /** 代码变更回调 */
  readonly onCodeChange?: (code: string, language: PlcLanguageType) => void;
}

// ============================================
// 函数式包装组件
// ============================================

const AIPlcCoderWrapper: React.FC<AIPlcCoderPluginProps> = ({
  aiCapabilityCode,
  initialCode = '',
  initialLanguage = 'st',
  onCodeChange,
  className = ''
}) => {
  return (
    <AIPlcCoder
      businessType={aiCapabilityCode}
      defaultCapabilityCode={aiCapabilityCode}
      initialCode={initialCode}
      initialLanguage={initialLanguage}
      onCodeChange={onCodeChange}
      className={className}
    />
  );
};

// ============================================
// Amis 渲染器注册
// ============================================

@Renderer({
  test: /\bagimx-ai-plc-coder$/,
  name: 'agimx-ai-plc-coder'
})
export default class AIPlcCoderPlugin extends React.Component<AIPlcCoderPluginProps> {
  static defaultProps: Partial<AIPlcCoderPluginProps> = {
    initialCode: '',
    initialLanguage: 'st'
  };

  render(): React.ReactNode {
    return (
        <div style={{ height: this.props.height || '90vh' }}>
            <AIPlcCoderWrapper {...this.props} />
        </div>
    );
  }
}

// ============================================
// 导出供外部使用
// ============================================

export * from './exports';